import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable, of } from 'rxjs';

import ruTranslation from '../../../assets/i18n/ru.json';

const SSR_TRANSLATIONS: Record<string, Translation> = {
  ru: ruTranslation as Translation,
};

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);

  getTranslation(lang: string): Observable<Translation> {
    if (isPlatformServer(this.platformId)) {
      return of(SSR_TRANSLATIONS[lang] ?? {});
    }
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
